import { render, staticRenderFns } from "./AppMessageDialog.vue?vue&type=template&id=cbeba166"
import script from "./AppMessageDialog.vue?vue&type=script&lang=js"
export * from "./AppMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports